export default {
  is_data_not_loaded: {
    // title: "Ошибка!",
    message: "Идёт синхронизация данных. Пожалуйста, попробуйте позднее.",
    variant: "error",
  },
};
